<template>
  <div class='hidden lg:flex gap-5 px-4 text-white ml-auto'>
    <OtivoButton
      size='large'
      colour='blue'
      class='w-full whitespace-nowrap mx-auto'
      @click='createAccount'
    >Get started
    </OtivoButton>
    <RouterLink :to="{ name: 'login' }" v-slot='{ navigate }' class='w-auto'>
      <OtivoButton
        size='large'
        colour='transparent'
        class='w-full whitespace-nowrap mx-auto'
        data-test='loginBtn'
        @click='navigate'
      >Log in
      </OtivoButton>
    </RouterLink>
  </div>
  <div class='lg:hidden grid items-center h-full'>
    <div class='size-12 relative inset-y-0 cursor-pointer md:mr-4' @click='menuOpen = !menuOpen'>
      <!-- Hamburger menu icon -->
      <svg
        xmlns='http://www.w3.org/2000/svg'
        viewBox='0 0 10 10'
        stroke='#eee'
        stroke-width='0.65'
        fill='rgba(0,0,0,0)'
        stroke-linecap='round'
        style='cursor: pointer'>
        <path
          :d="menuOpen ? 'M3,3L5,5L7,3M5,5L5,5M3,7L5,5L7,7' : 'M2,3L5,3L8,3M2,5L8,5M2,7L5,7L8,7'"
          ref='pathElement'>
          <animate
            ref='animateElement'
            dur='0.2s'
            attributeName='d'
            :values="
              menuOpen
                ? 'M2,3L5,3L8,3M2,5L8,5M2,7L5,7L8,7;M3,3L5,5L7,3M5,5L5,5M3,7L5,5L7,7'
                : 'M3,3L5,5L7,3M5,5L5,5M3,7L5,5L7,7;M2,3L5,3L8,3M2,5L8,5M2,7L5,7L8,7'
            "
            fill='freeze'
            begin='indefinite' />
        </path>
      </svg>
      <span class='sr-only'>Toggle nav menu</span>
      <!-- /Hamburger menu icon -->
    </div>
  </div>
</template>

<script setup lang='ts'>
import OtivoButton from '@/components/OtivoButton.vue'
import FreeToStartButton from '@/app/components/home/FreeToStartButton.vue'
import { inject, ref, Ref, watch } from 'vue'
import { createAccount } from '@/lib/AuthenticatorPlugin.ts'

const menuOpen = inject('headerNavOpen') as Ref<boolean>
const animateElement = ref<SVGAnimateElement | null>(null)

watch(menuOpen, () => {
  if (animateElement.value) {
    animateElement.value.beginElement()
  }
})
</script>

<style scoped></style>
